"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("./CustomText"));
const HashtagText = (props) => {
    const { text, style, onPress } = props;
    return (react_1.default.createElement(CustomText_1.default, { onPress: () => {
            if (onPress) {
                return onPress();
            }
            else {
                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                    screen: Routes_1.default.HASHTAG_DETAIL,
                    params: {
                        hashtag: text,
                        typeScreen: 0,
                    },
                });
            }
        }, style: [styles.text, style, { color: '#007AFF' }] },
        "#",
        text));
};
const styles = react_native_1.StyleSheet.create({
    text: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
});
exports.default = HashtagText;
